var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.8 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--services",
    x1: 3.6,
    y1: -1326.93,
    x2: 28.4,
    y2: -1351.74,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -1323.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bb23d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#659630"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.7,13.8c-1.6-.7-2.5-1.3-2.5-2.1s.6-1.2,1.8-1.2a7.2,7.2,0,0,1,3.2.8,1.1,1.1,0,0,0,1.3-.4h0L50,9.8a1.1,1.1,0,0,0-.4-1.4A8.3,8.3,0,0,0,45,7.3c-3.6,0-5.3,2.2-5.3,4.4s2.1,4,4.3,5,3.2,1.6,3.2,2.5-.7,1.3-1.9,1.3a7.2,7.2,0,0,1-3.7-1.1h0a1.1,1.1,0,0,0-.8-.1,1,1,0,0,0-.5.4l-.7,1.4a.8.8,0,0,0,.4,1h0a8.6,8.6,0,0,0,5.1,1.6c3.8,0,5.7-2.3,5.7-4.6S48.8,15.1,45.7,13.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,7.3a7.8,7.8,0,0,0-7.8,7.9v.3a7.7,7.7,0,0,0,7.3,8.2h.5a9.6,9.6,0,0,0,5.9-2,.8.8,0,0,0,.2-1.1h-.1l-.9-1.5-.5-.3-.7.2a5.4,5.4,0,0,1-3.7,1.3,4.4,4.4,0,0,1-4.4-3.8H65.9a1.2,1.2,0,0,0,.9-.9V14.5a7,7,0,0,0-6.9-7.2Zm-.1,3.2a3.5,3.5,0,0,1,3.7,3.1H55.6A3.7,3.7,0,0,1,59.5,10.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3,7.3a6,6,0,0,0-4.6,2.1l-.3-1.1a.8.8,0,0,0-.8-.7h-.8a1.1,1.1,0,0,0-1,.9v14a1.1,1.1,0,0,0,1,.9h1.5c.5,0,1.2,0,1.2-.9V12.7A4.5,4.5,0,0,1,76,10.8a2.8,2.8,0,0,1,1.3.3H78c.2,0,.4-.2.5-.5L79.3,9a1.1,1.1,0,0,0,0-.8C78.9,7.5,77.5,7.3,76.3,7.3Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,7.6H92.7a1.1,1.1,0,0,0-1.2.6l-4.1,9.1-4-9.1a.8.8,0,0,0-.8-.6H80.5a.7.7,0,0,0-.7.4c-.2.2-.1.5,0,.7l6.7,14.6a.9.9,0,0,0,.8.5h.2a.9.9,0,0,0,.8-.5L95,8.8A1.1,1.1,0,0,0,95,8,.9.9,0,0,0,94.2,7.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,7.6h1.9a.9.9,0,0,1,.9.9v14a.9.9,0,0,1-.9.9H97.2a.9.9,0,0,1-.9-.9V8.5a.9.9,0,0,1,.9-.9Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2.7a2.4,2.4,0,0,0-2.4,2.4h0a2.3,2.3,0,0,0,2.3,2.4h.1a2.4,2.4,0,0,0,2.4-2.4A2.4,2.4,0,0,0,98.2.7Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,18.3a.9.9,0,0,0-1.3.1h0l-.3.3a4.1,4.1,0,0,1-3.2,1.5,4.5,4.5,0,0,1-4.4-4.6h0a4.3,4.3,0,0,1,7.6-3.2.7.7,0,0,0,1.2.2l1.2-1.1a.9.9,0,0,0,.2-1.3h0a6.9,6.9,0,0,0-5.8-2.7,8.2,8.2,0,0,0-8.1,8.2,8.1,8.1,0,0,0,7.9,8.3h.2a7.1,7.1,0,0,0,6.1-3.3c.2-.3.4-.8-.3-1.4Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,7.3a7.9,7.9,0,0,0-7.9,7.9v.3a7.8,7.8,0,0,0,7.4,8.2h.5a9.3,9.3,0,0,0,5.8-2,.8.8,0,0,0,.3-1.1h-.2l-.9-1.5-.4-.3-.7.2a5.8,5.8,0,0,1-3.7,1.3,4.3,4.3,0,0,1-4.4-3.8h10.4c.5-.1.9-.4.9-.9s.1-.8.1-1.1a7,7,0,0,0-6.9-7.2Zm-.1,3.2a3.4,3.4,0,0,1,3.6,3.1h-7.5A3.7,3.7,0,0,1,124.8,10.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,13.8c-1.6-.7-2.5-1.3-2.5-2.1s.6-1.2,1.8-1.2a7.2,7.2,0,0,1,3.2.8.9.9,0,0,0,1.2-.4h.1l.5-1.1a1.2,1.2,0,0,0-.4-1.4,8.3,8.3,0,0,0-4.6-1.1c-3.7,0-5.3,2.2-5.3,4.4s2.1,4,4.3,5,3.2,1.6,3.2,2.5-.7,1.3-1.9,1.3a7.9,7.9,0,0,1-3.7-1h0a1.1,1.1,0,0,0-.8-.1,1,1,0,0,0-.5.4l-.7,1.4a1,1,0,0,0,.4,1.1h0a9.3,9.3,0,0,0,5.1,1.6c3.8,0,5.7-2.4,5.7-4.7S142.3,15.1,139.2,13.8Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,.5C3.6.5.5,3.6.5,16S3.6,31.5,16,31.5,31.5,28.4,31.5,16,28.4.5,16,.5Z",
    fill: "url(#linear-gradient--services)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10.7,
    r: 1.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 16,
    r: 1.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 21.4,
    r: 1.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,11.4a.8.8,0,0,1-.8.8H13.1a.8.8,0,0,1-.7-.8V9.9a.7.7,0,0,1,.7-.7H23a.8.8,0,0,1,.8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 14.5,
    width: 11.4,
    height: 2.97,
    rx: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 19.9,
    width: 11.4,
    height: 2.97,
    rx: 0.8,
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBadgeColor);
export default __webpack_public_path__ + "static/media/services-badge-color.9a2a4d1c4ef2a660444c29248a5b458b.svg";
export { ForwardRef as ReactComponent };